import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IS_PRIVATE_API } from '@personal-area/global/http/models';
import { Observable } from 'rxjs';

import { identityVerificationURLs } from '../constants/identity-verification';
import { IdentityVerificationRequest } from '../models/identity-verification-request';
import {
  IdentityVerificationResponse,
  IdentityVerificationSettings,
} from '../models/identity-verification-response';

@Injectable()
export class IdentityVerificationApiService {
  constructor(private _http: HttpClient) {}

  public requestVerify(
    userId: number,
    data: IdentityVerificationRequest,
  ): Observable<void> {
    return this._http.post<void>(
      identityVerificationURLs.request(userId),
      data,
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }

  public checkRequest(
    userId: number,
  ): Observable<IdentityVerificationResponse> {
    return this._http.get<IdentityVerificationResponse>(
      identityVerificationURLs.status(userId),
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }

  public updateBirthDate(birthDate: string): Observable<{ birthDate: string }> {
    return this._http.patch<{ birthDate: string }>(
      identityVerificationURLs.updateBirthDate(),
      { birthDate },
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }

  public initializeIdentityVerification(
    userId: number,
    level?: string,
  ): Observable<IdentityVerificationSettings> {
    return this._http.post<IdentityVerificationSettings>(
      identityVerificationURLs.init(userId),
      { level },
      { context: new HttpContext().set(IS_PRIVATE_API, true) },
    );
  }
}
